/* Miralleve — corrige a remoção de item no cart drawer.
   O tema (Sabino Vision) não intercepta o link nativo "Remover" no cart-drawer principal,
   fazendo o clique navegar cru para /cart/change (erro "nenhum parâmetro de linha ou id válido").
   Este script intercepta o clique dentro de <cart-drawer>, remove via AJAX (/cart/change.js)
   e re-renderiza o drawer pela Section Rendering API. Fora do drawer, mantém o comportamento nativo. */
(function () {
  if (window.__vdtCartRemoveFix) return;
  window.__vdtCartRemoveFix = true;

  document.addEventListener('click', async function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="/cart/change"]');
    if (!a) return;
    var drawer = a.closest('cart-drawer');
    if (!drawer) return; // fora do cart drawer: deixa o comportamento nativo

    e.preventDefault();
    e.stopImmediatePropagation();

    var url = new URL(a.href, location.origin);
    var id = url.searchParams.get('id');
    var quantity = parseInt(url.searchParams.get('quantity'));
    if (isNaN(quantity)) quantity = 0;

    var section = drawer.closest('[id^="shopify-section-"]');
    var sectionId = section ? section.id.replace('shopify-section-', '') : null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

    try {
      var data = await (await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity, sections: sectionId ? [sectionId] : [] })
      })).json();

      if (sectionId && data.sections && data.sections[sectionId]) {
        var fresh = new DOMParser()
          .parseFromString(data.sections[sectionId], 'text/html')
          .querySelector('cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }

      document.querySelectorAll('cart-count, .cart-count').forEach(function (el) {
        try { el.textContent = data.item_count; } catch (_) {}
      });
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: data } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (err) {
      window.location.href = a.href; // fallback: comportamento nativo
    }
  }, true); // fase de captura: roda antes de qualquer navegação
})();
